import { useState,useEffect,useContext } from 'react'
import { useParams,useNavigate } from 'react-router-dom'
import { Alert, Button, Grid, Card, CardContent, CardMedia, Menu, MenuItem, Modal, Fade, Box, Typography, FormControl, SwipeableDrawer, Autocomplete, TextField, FormControlLabel, Switch } from '@mui/material'
import SearchBox from '../../../components/SearchBox'
import { post } from '../../../utils/axios'
import { Context } from '../../../context/Context'
import AccessLocationModal from '../../../components/AccessLocationModal'

import './Businesses.css'

const Businesses = () => {

    const navigate = useNavigate()
    const context = useContext(Context)

    const { guildId } = useParams()
    const [addressses,setAddresses] = useState([])
    const [showLocationModal,setShowLocationModal] = useState(false)
    const [isLoading,setIsLoading] = useState(true)
    const [businesses,setBusinesses] = useState([])
    const [filteredBusinesses,setFilteredBusinesses] = useState([])
    const [searchText,setSearchText] = useState('')
    const [sortMenuOpen,setSortMenuOpen] = useState(false)
    const [openChooseCityModal,setOpenChooseCityModal] = useState(false)
    const [provinces,setProvinces] = useState([])
    const [cities,setCities] = useState([])
    const [provinceId,setProvinceId] = useState(0)
    const [cityId,setCityId] = useState(0)
    const [cityTitle,setCityTitle] = useState('')
    const [showDrawer,setShowDrawer] = useState(false)
    const [showBusinesses,setShowBusinesses] = useState(false)
    const open = Boolean(sortMenuOpen)

    const guilds = {
        43: 'ورزشی',
        63: 'فرهنگی آموزشی',
        64: 'رستوران',
        144: 'هتل و اقامتگاه',
        165: 'اینترنت',
        204: 'فروش آنلاین'
    }

    const getData = async () => {
        post('General/GetProvince').then(({data}) => {
            if(data.isSuccess){
                const items = []
                data.data.map(item => items.push({
                    label: item.title,
                    id: item.id.toString()
                }))
                setProvinces(items)
            }
        })
        await post('Address/GetAllAddressByPersonId').then(({data}) => {
            if(data.isSuccess){
                if(data.data.length){
                    if(Object.keys(context.address).length){
                        setProvinceId(context.address.provinceId || 0)
                        setCityId(context.address.cityId || 0)
                    }else{
                        const lastAddress = data.data[data.data.length - 1]
                        if(lastAddress)
                            context.setAddress(lastAddress)
                    }
                }
                setAddresses(data.data)
            }
        })
        const postedData = {
            guildId
        }
        post('Business/GetAllBusinessByGuild',postedData).then(({ data }) => {
            if(data.isSuccess)
                setBusinesses(data.data)
        }).finally(() => {
            setIsLoading(false)
        })
        if(context.currentCityId){
            setProvinceId(context.currentProvinceId)
            setCityId(context.currentCityId)
        }
    }

    useEffect(() => {
        getData()
    },[])

    useEffect(() => {
        if(provinceId){
            const postedData = {
                provinceId
            }
            post('General/GetCity',postedData).then(({data}) => {
                if(data.isSuccess){
                    const items = []
                    data.data.map(item => items.push({
                        label: item.title,
                        id: item.id.toString()
                    }))
                    setCities(items)
                }
            })
        }
    },[provinceId])

    useEffect(() => {
        if(context.showAllCities || guildId == 204){
            setFilteredBusinesses([...businesses])
            setShowBusinesses(true)
        }else if(businesses.length && cityId){
            const filteredData = guildId != 204 ? [...businesses].filter(business => business.cityId == cityId) : [...businesses]
            setFilteredBusinesses(filteredData)
            setShowBusinesses(true)
        }
    },[businesses,cityId,context.showAllCities,guildId])

    useEffect(() => {
        const city = cities.find(c => c.id == cityId)
        if(city)
            setCityTitle(city.label)
    },[cityId,cities])

    useEffect(() => {
        if(context.address.id){
            const address = addressses.find(addr => addr.id == context.address.id)
            if(address){
                setProvinceId(address.provinceId)
                setCityId(address.cityId)
            }
            setShowDrawer(false)
        }
    },[context.address.id])

    useEffect(() => {
        const filteredData = [...businesses]
        if(cityId && guildId != 204 && !context.showAllCities){
            const city = cities.find(c => c.id == cityId)
            setFilteredBusinesses(filteredData.filter(d => (d.title.includes(searchText) || (searchText && d.products && d.products?.includes(searchText))) && d.cityId == city.id))
        }else
            setFilteredBusinesses(filteredData.filter(d => d.title.includes(searchText) || (searchText && d.products && d.products?.includes(searchText))))
    },[searchText,context.showAllCities])

    const goToServices = business => {
        context.setBusinessParticipator(business.participator || 0)
        if(business.subGuildId != 162 && business.subGuildId != 181)
            navigate(`/app/businesses/services/${business.id}`)
        else
            window.open(business.website,'_blank')
    }

    const handleClick = e => {
        setSortMenuOpen(e.currentTarget)
    }

    const handleClose = () => {
        setSortMenuOpen(null)
    }

    const sortBusinesses = type => {
        handleClose()
        const filteredData = [...businesses]
        switch(type){
            case 'default':
                setFilteredBusinesses(filteredData)
                break
            case 'rate':
                setFilteredBusinesses(filteredData.sort((a,b) => b.businessRank - a.businessRank))
            break
        }
    }

    const setCurrentAddress = address => {
        context.setCurrentCityId(0)
        context.setAddress(address)
    }

    const setGlobalProvinceId = provinceId => {
        setProvinceId(provinceId)
        setCityId(0)
        context.setCurrentProvinceId(provinceId)
    }

    const setGlobalCityId = cityId => {
        setCityId(cityId)
        context.setCurrentCityId(cityId)
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '92%',
        maxHeight: '80%',
        overflowY: 'auto',
        boxSizing: 'border-box',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    }
    
    return (
        <div id="businesses-parent" className="safe-area">
            {showLocationModal && 'geolocation' in navigator ? <AccessLocationModal hideModal={setShowLocationModal} /> : ''}
            <h2>جستجو</h2>
            {guildId != 204 ? <span className="current-address" onClick={() => setShowDrawer(true)}>{context.address && context.address.title ? (context.address.title.length > 10 ? (context.address.title.slice(0,10) + ' ...') : context.address.title) : 'انتخاب آدرس'}</span> : ''}
            <Grid container spacing={guildId != 204 ? 1 : 0}>
                {guildId != 204 ? <Grid item xs={3}>
                    <Button fullWidth variant="contained" color="secondary" onClick={() => setOpenChooseCityModal(true)} className="search-by-city-btn">{context.showAllCities ? 'همه' : (cityId ? (`${cityTitle && cityTitle.length > 6 ? (cityTitle.slice(0,6) + ' ...') : (cityTitle || '-')}`) : 'جستجو شهر')}</Button>
                </Grid> : ''}
                <Grid item xs={guildId != 204 ? 9 : 12}>
                    <SearchBox searchText={searchText} setSearchText={setSearchText} />
                </Grid>
            </Grid>
            <Modal open={openChooseCityModal} onClose={() => setOpenChooseCityModal(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Fade in={openChooseCityModal}>
                    <Box sx={{...style,pb: 5}}>
                        <i className="fal fa-x close-modal-btn" onClick={() => setOpenChooseCityModal(false)}></i>
                        <Typography variant="h6" component="h2" sx={{ mb: 1,fontSize: 18 }}>انتخاب شهر</Typography>
                        <FormControlLabel sx={{mb: context.showAllCities ? 0 : 3}} control={<Switch checked={context.showAllCities} onChange={() => context.setShowAllCities(!context.showAllCities)} />} label="جستجو در همه استان ها" />
                        {!context.showAllCities ? <>
                            <FormControl fullWidth sx={{mb: 3}}>
                            <Autocomplete
                                options={provinces}
                                autoHighlight
                                value={provinces.find(province => province.id == provinceId)}
                                onChange={(e,value) => setGlobalProvinceId(value?.id || 0)}
                                getOptionLabel={(option) => option.label}
                                noOptionsText="یافت نشد"
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="استان"
                                        inputProps={{
                                            ...params.inputProps,
                                            autoComplete: 'new-password'
                                        }}
                                    />
                                )}
                            />
                        </FormControl>
                        <FormControl fullWidth>
                            <Autocomplete
                                options={cities}
                                autoHighlight
                                value={cities.find(city => city.id == cityId)}
                                onChange={(e,value) => setGlobalCityId(value?.id || 0)}
                                getOptionLabel={(option) => option.label}
                                noOptionsText="یافت نشد"
                                disabled={!provinceId}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="شهر"
                                        inputProps={{
                                            ...params.inputProps,
                                            autoComplete: 'new-password'
                                        }}
                                    />
                                )}
                            />
                        </FormControl>
                        </> : ''}
                        <Button fullWidth variant="contained" color="success" sx={{ py: 1.5,mt: 2.5 }} onClick={() => setOpenChooseCityModal(false)} disabled={!context.showAllCities && (!provinceId || !cityId)}>تایید و جستجو</Button>
                    </Box>
                </Fade>
            </Modal>
            <div className="inline">
                <h2>{searchText ? `نتایج : ${searchText}` : `لیست ${guilds[guildId] || 'کسب و کار ها'}`}</h2>
                <span onClick={handleClick} className="sort-button">مرتب سازی</span>
                <Menu anchorEl={sortMenuOpen} open={open} onClose={handleClose}>
                    <MenuItem onClick={() => sortBusinesses('default')}>پیشفرض</MenuItem>
                    <MenuItem onClick={() => sortBusinesses('rate')}>بالاترین امتیاز</MenuItem>
                </Menu>
            </div>
            {filteredBusinesses.length && (context.showAllCities || guildId == 204 || (provinceId && cityId)) && showBusinesses ? filteredBusinesses.map(business => <Grid item px={0.3} key={business.id}><Card sx={{ width: '100%',mb: 5 }} className="business-item" onClick={() => goToServices(business)}>
                <CardMedia component="img" height="120" image={business.photo1 ? `https://petromah.sabinarya.com${business.photo1}` : '/assets/img/default-banner.jpg'} alt={business.title} sx={{ borderRadius: '4px 4px 0 0' }} />
                <CardContent className="card-content-area">
                    <img src={business.logo ? `https://petromah.sabinarya.com${business.logo}` : '/assets/img/default-logo.jpg'} className="businiess-logo" alt={business.title} />
                    <span className="business-title">{business.title}</span>
                    <span className="business-star"><i className="fas fa-star" style={{ color: 'gold' }}></i> {business.businessRank > 0 ? (business.businessRank / 20).toFixed(1) : 0} <span>({business.participator || 0} شرکت کننده)</span></span>
                    <Button variant="contained" color={business.subGuildId != 162 && business.subGuildId != 181 ? 'primary' : 'success'}>{business.subGuildId != 162 && business.subGuildId != 181 ? 'ثبت سفارش' : 'ورود به فروشگاه'}</Button>
                </CardContent>
            </Card></Grid>) : (isLoading ? <><div className="business-placeholder animate"></div><div className="business-placeholder animate"></div><div className="business-placeholder animate"></div></> : <Alert severity="info">کسب و کاری یافت نشد</Alert>)}
            <SwipeableDrawer anchor="bottom" open={showDrawer} onClose={() => setShowDrawer(false)} onOpen={() => setShowDrawer(true)} id="addresses-drawer">
                <div id="addresses-drawer-content">
                    <h3>آدرس ها</h3>
                    <Button fullWidth variant="outlined" color="secondary" sx={{ py: 1.5,mb: 2.6 }} onClick={() => navigate('/app/profile/addresses/add')}>افزودن آدرس جدید</Button>
                    {addressses.map(address => <div key={address.id} className={`drawer-address-item ${context.address && context.address.id == address.id ? 'active' : ''}`} onClick={() => setCurrentAddress(address)}>
                        <span className="address-title">{address.title}</span>
                        <span className="address-detail">{`${address.address.slice(0,30)} ...`}</span>
                        <i className="fal fa-pen" onClick={() => navigate(`/app/profile/addresses/${address.id}`)}></i>
                    </div>)}
                </div>
            </SwipeableDrawer>
        </div>
    )
}

export default Businesses